import {READ} from '../../../../store/type'
import {ENTITY_NAME} from "./type";

export const mutations = {
  [ENTITY_NAME + READ]: (state, { data, fieldInfoList}) => {
    state.data = data
    state.fieldInfoList = fieldInfoList
  }
};
